// Counts all confirmed packages in the current manifest across both tables.
// Only COMPLETE encomiendas count — DRAFT packages do not consume sequence numbers.
export const getNextPackageNumber = async (supabase, manifestId) => {
  // Count casillero shipments entered in this manifest
  const { count: casilleroCount } = await supabase
    .from('shipments')
    .select('*', { count: 'exact', head: true })
    .eq('entry_manifest_id', manifestId);

  // Count encomienda packages from COMPLETE encomiendas in this manifest
  const { data: completeEncs } = await supabase
    .from('encomiendas')
    .select('id')
    .eq('manifest_id', manifestId)
    .eq('status', 'COMPLETE');

  let encomiendaCount = 0;
  if (completeEncs && completeEncs.length > 0) {
    const encIds = completeEncs.map(e => e.id);
    const { count: epCount } = await supabase
      .from('encomienda_packages')
      .select('*', { count: 'exact', head: true })
      .in('encomienda_id', encIds);
    encomiendaCount = epCount || 0;
  }

  const total = (casilleroCount || 0) + encomiendaCount;
  console.log('[getNextPackageNumber]', {
    manifestId,
    casilleroCount,
    encomiendaCount,
    total,
    nextNumber: total + 1,
  });

  return total + 1;
};
